import useSWR from "swr";

const optionArgs = {};

export const useGender = (options = optionArgs) => {
  const { data, error } = useSWR(
    `${process.env.REACT_APP_BASE_URL_REQUESTS}/data-master/gender`,
    { ...options }
  );

  return {
    gender: data,
    isLoading: !error && !data,
    isError: error,
  };
};
